module.exports = __webpack_public_path__ + "img/msff-logo.eaa335a4.svg";